
const form = () => {
    const forms = document.querySelectorAll(".js-form");   
    const recaptchaSiteKey = document.getElementById("hdnRecaptchaSiteKey").value;   

    forms.forEach((form) => {         
        window.jQuery(form).on("change keyup blur input", "[required]", async function () {
            await ValidateForm(form);
        });   

        window.jQuery('.form-check-input').change(function () {
            let val = this.value;          

            let hiddenkey = 'hdn_'+ $(this).data("hiddenkey");          

            let hiddenInput = document.getElementById(hiddenkey);           

            let array = [];

            let hiddenValue = $(hiddenInput).val();

            if (hiddenValue != '') {
                array = hiddenValue.split(',');
            }        

            if (this.checked) {                
                array.push(val);   
            } else {              
                array.pop(val);  
            }          

            let newVal = '';

            if (array.length > 0) {
                newVal = array.join(",");
            }

            $(hiddenInput).val(newVal);
        });  

        form.querySelector('.js-submit').addEventListener("click", async function () { await SubmitForm(event, form, recaptchaSiteKey) });  
    });
};


const ValidateForm = (form) => {
    if (form) {       
       
        let requiredFields = form?.querySelectorAll("[required]");          

        if (requiredFieldsNotEmpty(requiredFields)) {
             EnableSubmitFormButton(form);
        } else {
             DisableSubmitFormButton(form);
        }
    }
}

const DisableSubmitFormButton = (form) => {
    if (form) {      
        let submitButtonElement = form?.querySelector('.js-submit');

        if (!submitButtonElement.classList.contains("disabled")) 
            submitButtonElement.classList.add("disabled");       
    }
}

const EnableSubmitFormButton = (form) => {
    if (form) {
        let submitButtonElement = form?.querySelector('.js-submit');

        if (submitButtonElement.classList.contains("disabled"))
            submitButtonElement.classList.remove("disabled");
    }
}

const InitLoading = (form) => {
    if (form) {
        let submitButtonElement = form?.querySelector('.js-submit');
        let parentDiv = submitButtonElement.parentElement;        

        $(parentDiv).append(`
            <div class="form-loading-wrapper">
                <div class="spinner-border text-primary" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>
                     `);
    }   
}

const RemoveLoading = (form) => {
    if (form) {
        let loadingWrapper = form?.querySelector('.form-loading-wrapper');

        if (loadingWrapper)
            $(loadingWrapper).remove();
    }
}


function requiredFieldsNotEmpty(requiredFields) {
    let flag = true;

    requiredFields.forEach((field) => {

        if (field.value.trim() == "")
            flag = false;       
    });
    return flag;
}

const DisplayResponseMessage = (form, message, statusClass) => {
    if (form) {
        let submitButtonElement = form?.querySelector('.js-submit');
        let parentDiv = submitButtonElement.parentElement;

        $(parentDiv).append(`
            <p class="response-info text-${statusClass}">
                        ${message}
            </p>
                     `);
    }
}

const ClearFormValidityStyle = (form) => {
    if (form) {
        Array.from(form.querySelectorAll('.is-valid')).forEach(
            (el) => el.classList.remove('is-valid')
        );
    }
}


const SubmitForm = (e, form, recaptchaSiteKey) => {
    e.preventDefault();  

    let displayResponseMessage = form?.querySelector('.response-info');

    if (displayResponseMessage)
        $(displayResponseMessage).remove();

    if (!$(form).validate().form()) return false;

    //run recaptcha

    grecaptcha.ready(async function () {
        grecaptcha
            .execute(recaptchaSiteKey, { action: "submit" })
            .then(async function (token) {               

                DisableSubmitFormButton(form);
                InitLoading(form);

                const hidden_formId = form.querySelector('[name="hidden_formId"]');
                const hidden_pageId = form.querySelector('[name="hidden_pageId"]');

                const dataObj = new Object();
                dataObj.FormId = $(hidden_formId).val();
                dataObj.PageId = $(hidden_pageId).val();

                const formElementsList = [];

                const formElements = form.querySelectorAll("[data-key]");

                for (const formElement of formElements) {
                    let key = $(formElement).data("key");
                    let label = $(formElement).data("label");
                    let value = $(formElement).val();

                    let formElementObj = new Object();
                    formElementObj.Key = key;
                    formElementObj.Label = label;
                    formElementObj.Value = value;

                    formElementsList.push(formElementObj);
                }

                dataObj.FormData = formElementsList;

                const formAction = $(form).attr("action");
                const requestVerificationToken = form.querySelector('[name="__RequestVerificationToken"]');
                const locale = document.head.querySelector('meta[name="locale"]');

                fetch(formAction, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'RequestVerificationToken': $(requestVerificationToken).val(),
                        'culture': locale.content,
                        'recaptcha': token
                    },
                    body: JSON.stringify(dataObj),
                    })
                    .then(function (response) {
                        if (response.status != 200)
                            throw new Error(response.status);
                        else
                            return response.json();
                    })
                    .then(function (data) {                      

                        if (data.statusCode == 200) {
                            $(form)[0].reset();
                            DisplayResponseMessage(form, data.message, 'success');
                        } else {
                            DisplayResponseMessage(form, data.message, 'danger');
                        }
                        ClearFormValidityStyle(form);
                        RemoveLoading(form);
                        EnableSubmitFormButton(form);
                    })
                    .catch(error => {
                        RemoveLoading(form);
                        EnableSubmitFormButton(form);
                        DisplayResponseMessage(form, 'Server Error.\n' + error, 'danger');
                    }); 

            });
    });

};


export { form };